import { BaseModule } from "./base.module";
import { StorageModule } from "./storage.module";

/**
 * 
 */
export class AnalyticsModule extends BaseModule {

	googleAnalyticsInstances = [];
	location;
	dataLayerCache = new Map();
	mutationCache = new Map();
	nonFunctionalCookiesAccepted = false; // safe default value for this module
	mutationObserver;
	storage = new StorageModule();
	uuid = '';
	ticketsSucessPage = false;

	allowedFormPreSubmitEventTargets = [
		{
			target: 'tickets-flow',
			eventType: 'add_payment_info',
		}
	];

	generateUuid() {
		// console.log('[AnalyticsModule] generateUuid');
		if (
			this.nonFunctionalCookiesAccepted === true &&
			this.storage &&
			this.storage.storageAvailable('sessionStorage') === true
		) {
			if (
				typeof window !== 'undefined' &&
				window.crypto
			) {
				this.uuid = window.crypto.randomUUID();
				this.storage.setItem('uuid', this.uuid);
				// console.log('[AnalyticsModule] generated UUID');
				this.storage.getItem('uuid', this.uuid);
			} else {
				// console.log('[AnalyticsModule] not setting uuid');
			}
		}
	}

	/**
	 * 
	 * @returns 
	 */
	getAllGoogleAnalyticsInstances() {
		let instances = [];
		if (window && window.ga && window.ga.getAll) {
			instances = window.ga.getAll();
		}
		return instances;
	}

	onFormInvalid(data) {
		// console.log('[AnalyticsModule] a form validation happened where input was not valid');
	}

	onFormPreSubmit(data) {
		// console.log('[AnalyticsModule] onFormPreSubmit', data, this);
		this.allowedFormPreSubmitEventTargets.forEach((eventTarget) => {
			if (this.nonFunctionalCookiesAccepted === true) {
				let allowedFormPreSubmitEventTarget = data.target.closest(eventTarget.target);
				if (allowedFormPreSubmitEventTarget) {
					let _object = this.createDataLayerEventObject(eventTarget.eventType);
					_object = this.decorateDataLayerEventObject(_object, eventTarget.eventType);
					// console.log('[AnalyticsModule] allowedFormPreSubmitEventTarget', allowedFormPreSubmitEventTarget);
					this.dataLayerCache.set(_object, _object);
					// push onto the data layer and afterwards delete the item from the cache
					// double entry add_payment_info in data layer? 
					// this.triggerEventOnElement('nexus.analytics.event.add_payment_info', document, _object); 
					this.runDataLayerCachePipeline();
				}
			}
		});
	}

	/**
	 * Go through any dataLayerCache stuff,
	 * for stuff that may need permission to actually collect and use
	 * Run this if you have obtained permission to use non functional cookies!
	 */
	runDataLayerCachePipeline() {
		if (this.nonFunctionalCookiesAccepted === true) {
			this.dataLayerCache.forEach((dataLayerCacheItem) => {
				// push it to google
				// console.log('[AnalyticsModule] pushing', dataLayerCacheItem, 'to scroogle'); // to non-evil oligopolist :)
				dataLayer.push(dataLayerCacheItem);
				// delete the cache item, because it is now sent or at least pushed onto the dataLayer
				// (the super wonky google window.dataLayer)
				// console.log('[AnalyticsModule] deleting', dataLayerCacheItem, 'from cache', this.dataLayerCache);
				this.dataLayerCache.delete(dataLayerCacheItem);
			});
		}
	}

	setEventListeners() {

		if (typeof document !== 'undefined') {
			document.addEventListener('non-functional-cookies-accepted', this.onNonFunctionalCookiesAcceptedEvent.bind(this));
			document.addEventListener('cookie-module-loaded', this.onCookieModuleLoaded.bind(this));
			document.addEventListener('nexus.analytics.form.submit.pre-submit', this.onFormPreSubmit.bind(this));
			document.addEventListener('nexus.analytics.form.submit.invalid', this.onFormInvalid.bind(this));
			document.addEventListener('nexus.analytics.event.begin_checkout', this.onBeginCheckout.bind(this));
			document.addEventListener('nexus.analytics.event.add_payment_info', this.onAddPaymentInfo.bind(this));
			document.addEventListener('revoke-cookie-choice', this.onRevokeCookieChoice.bind(this));
		}
		if (typeof window !== 'undefined') {
			window.addEventListener('hashchange', (event) => {
				// console.info('[AnalyticsModule] hashchange event', event);
				this.onHashChange(event);
			});

		}
	}

	onRevokeCookieChoice() {
		// console.log('[AnalyticsModule] onRevokeCookieChoice');
		this.nonFunctionalCookiesAccepted = false;
	}

	onBeginCheckout(event) {
		// console.log('[AnalyticsModule] onBeginCheckout', event);
		if (window.location.pathname.endsWith('/tickets')) {
			dataLayer.push({ ecommerce: null });
			let _object = this.createDataLayerEventObject('begin_checkout');
			_object = this.decorateDataLayerEventObject(_object, 'begin_checkout');
			dataLayer.push(_object);
			this.dataLayerCache.set(_object, _object);
		}
	}

	onAddPaymentInfo(event) {
		// console.log('[AnalyticsModule] onAddPaymentInfo', event);
		if (window.location.pathname.endsWith('/tickets')) {
			let _object = this.createDataLayerEventObject('add_payment_info');
			_object = this.decorateDataLayerEventObject(_object, 'add_payment_info');
			// dataLayer.push();
			this.dataLayerCache.set(_object, _object);
		}
	}

	onHashChange(event) {
		// console.log('[AnalyticsModule] onHashChange', event);
		if (window.location.pathname.endsWith('/tickets')) {
			let _object = this.createDataLayerEventObject('pageview');
			_object = this.decorateDataLayerEventObject(_object, 'pageview');
			dataLayer.push(_object);
			this.dataLayerCache.set(_object, _object);
		}
		// console.log('[AnalyticsModule] onHashChange - dataLayerCache is now', this.dataLayerCache);
	}

	onCookieModuleLoaded(data) {
		// console.log('[AnalyticsModule] onCookieModuleLoaded data', data);
		if (data && data.module && typeof data.module.accepted == 'boolean') {
			// data.module is the CookieModule!
		}
	}

	onNonFunctionalCookiesAcceptedEvent(data) {
		// console.log('[AnalyticsModule] onNonFunctionalCookiesAcceptedEvent data', data);
		this.nonFunctionalCookiesAccepted = true;
		// TODO: TCF revoke / cookie module callback
	}

	/**
	 * Get info about synchronously loaded (RESTful) page
	 */
	cacheWindowLocation() {
		if (window.location) {
			// where were we when loading the window/tab?
			this.location = Object.assign({}, { location: window.location }).location;
			// console.log('[AnalyticsModule] cache location', this.location);
		}
	}

	initialize() {
		// console.log('[AnalyticsModule] initialize');
		this.generateUuid();
		this.setupMutationObserver();
		this.setEventListeners();
		this.cacheWindowLocation();
		this.googleAnalyticsInstances = this.getAllGoogleAnalyticsInstances();
		this.setupShop();
		this.isTicketsSucessPage();
	}

	isTicketsSucessPage() {
		// console.log('[AnalyticsModule] isTicketsSucessPage');
		if (this.location.pathname.endsWith("tickets/tickets-success/")) {
			this.ticketsSuccessPage = true;
		}
	}

	/**
	 * 
	 */
	setupMutationObserver() {
		this.mutationObserver = new MutationObserver(this.handleMutationsObservation.bind(this));
		this.mutationObserver.observe(document.documentElement, {
			attributes: true,
			childList: true,
			subtree: true,
			// attributeFilter: [

			// ]
			characterData: true,
		});
	}

	/**
	 * No mutation, no observation
	 * 
	 * @param {*} mutations 
	 */
	handleMutationsObservation(mutations) {
		// console.log('handleMutationsObservation', mutations);
		if (mutations) {
			mutations.forEach((mutation) => {
				let parsedMutation = this.parseMutation(mutation);
				// if (parsedMutation) {
				// 	this.mutationCache.set(mutation.target, parsedMutation);
				// }
			});
		}
		// console.log('[AnalyticsModule] this.mutationCache updated, it is now', this.mutationCache);
	}

	parseMutation(mutation) {
		let output = null;
		// console.log('[AnalyticsModule] parseMutation', mutation, mutation.target.nodeName);
		let nodeName = mutation.target.nodeName.toLowerCase();
		switch (nodeName) {
			case 'tickets-navigation':
				output = this.mutationCache.set(mutation.target.nodeName.toLowerCase(), mutation.target);
				break;
			default:
				break;
		}

		return output;
	}

	/**
	 * 
	 */
	handleGoogleAnalyticsInstances() {
		// console.log('[AnalyticsModule] handleGoogleAnalyticsInstances');
		this.googleAnalyticsInstances.forEach((googleAnalyticsInstance) => {
			this.handleGoogleAnalyticsInstance(googleAnalyticsInstance);
		});
	}

	/**
	 * 
	 * @param {*} googleAnalyticsInstance 
	 */
	handleGoogleAnalyticsInstance(googleAnalyticsInstance) {
		// console.log('[AnalyticsModule] handleGoogleAnalyticsInstance', googleAnalyticsInstance);
	}

	/**
	 * Shop-related events handling
	 * 
	 */
	setupShop() {
		console.log('[AnalyticsModule] setupShop');
		this.setupShopPageView();
		this.setupVirtualPageViewEvents();
		this.setupCheckoutEvents();
		this.setupAddPaymentInfoEvents();
	}

	/**
	 * Factory method for creating a data layer event type by type string name
	 * 
	 * @param {*} type 
	 * @returns object
	 */
	createDataLayerEventObject(type = 'pageview') {
		let _object = {};
		_object['event'] = type;
		switch (_object['event']) {
			case 'pageview':

				break;

			default:
				break;
		}
		return _object;
	}

	/**
	 * Method to decorate a data layer event object
	 * 
	 * @param {*} _object 
	 * @param {*} type 
	 * @param {*} _extraDecoration 
	 * @returns 
	 */
	decorateDataLayerEventObject(_object = {}, type = 'pageview', _extraDecoration = {}) {
		let decoration = {}; // default

		let ticketsOrderOverviewElement = document.querySelector('tickets-order-overview');
		if (ticketsOrderOverviewElement && ticketsOrderOverviewElement.ecommerce) {
			let ecommerce = ticketsOrderOverviewElement.ecommerce;
			switch (type) {
				case 'pageview':
					if (typeof window !== 'undefined' && window.location) {
						decoration = {
							event_params: {
								event_type: 'auto',
								// custom page_location property
								page_location: `${window.location.href}`,
							}

						};
					}
					break;
				case 'add_payment_info':
					if (typeof window !== 'undefined' && window.location) {
						decoration = {
							event_type: 'ecommerce',
							form_signup_provider: "cm", // hard coded...
							ecommerce: ecommerce
						};

					}
					break;
				case 'sign_up':
					if (typeof window !== 'undefined' && window.location) {
						decoration = {
							event_type: 'forms',
							form_signup_provider: "cm", // hard coded...
							ecommerce: ecommerce
						};
					}
					break;
				case 'begin_checkout':
					if (typeof window !== 'undefined' && window.location) {
						decoration = {
							event_type: 'ecommerce',
							form_signup_provider: "cm", // hard coded...
							ecommerce: ecommerce
						}
					};
					break;

				default:
					break;
			}
		}
		_object = Object.assign(_object, decoration);
		_object = Object.assign(_object, _extraDecoration);
		// console.log('[AnalyticsModule] decorated object', _object, 'with', decoration);
		return _object;
	}


	/**
	 *  Setup page view, for the initial load of the page.
	 * 
	 */
	setupShopPageView() {

		if (window.location.pathname.endsWith('/tickets')) {
			// console.log('[AnalyticsModule] setupShopPageView');
			let _object = this.createDataLayerEventObject('pageview');
			_object = this.decorateDataLayerEventObject(_object, 'pageview');
			dataLayer.push(_object);
			this.dataLayerCache.set(_object, _object);
		}

	}

	/**
	 * Setup virtual page view events, for in-page navigations.
	 * One would use for example hashchange event to get info about steps
	 * 
	 */
	setupVirtualPageViewEvents() {
		// console.log('[AnalyticsModule] setupVirtualPageViews');
	}

	/**
	 * Handle an in-page event, as a (virtual) page view
	 * One would use for example hashchange event to get info about steps
	 * 
	 */
	setupAddPaymentInfoEvents() {
		// console.log('[AnalyticsModule] setupAddPaymentInfoEvents');
	}

	/**
	 * When a shopping cart is filled with stuff, but not yet checked out.
	 * Would be a last step.
	 * 
	 */
	setupCheckoutEvents() {
		// console.log('[AnalyticsModule] setupCheckoutEvents');
	}
}